// extracted by mini-css-extract-plugin
module.exports = {"categoryAndReasonInput":"categoryAndReasonInput__QfwRm","switcher":"switcher__9P6bi","input":"input__A8Qzd","label":"label__EACQA"};